import React from "react";
import { useRef } from "react";
import styled from "styled-components";
import Container from "../Container";
import { H1Style, Body } from "../Typography";
import {
  ModuleBtnStyle,
  ModulePrimaryBtn,
  ModuleOutlineBtn,
  CalendlyBtn
} from "../Button";
import StretchLogoDesktop from "./StretchLogoDesktop";
import StretchLogoMobile from "./StretchLogoMobile";

import PardotForm from './../Pardot/PardotForm';
import Modal from './../Pardot/Modal';
// import Modal from './../Pardot/ModalTwo';
// import {ModalRef} from './../Pardot/ModalTwo';

import theme from "../../styles/theme";

const StyledCta = styled.div`
  display: flex;
  width: 100%;
  background: ${() => theme.colors.green5};
  padding: 56px 0;
  ${theme.media.desktopUp`
    padding: 120px 0;
  `};
`;

const RelativeWrapper = styled.div`
  position: relative;
`;

const CtaContent = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 320px;
  left: 50%;
  transform: translateX(calc(-50% - 10px));
  top: -32px;
  padding: 16px;
  ${theme.media.tabletUp`
    padding: 0;
    transform: none;
    top: 0px;
    left: 33%;
    max-width: 500px;
  `};
  ${theme.media.desktopUp`
    left: 43%;
    max-width: 500px;
  `};
`;

const StyledTitle = styled.p`
  ${H1Style};
  color: ${() => theme.colors.green5};
  margin-bottom: 0;
  ${props => theme.media.tabletUp`
    margin-top: 0;
  `};
  ${props => theme.media.desktopUp`
    margin-top: unset;
    left: 33%;
    max-width: 500px;
  `};
`;

const StyledSubTitle = styled(Body)`
  color: ${() => theme.colors.green5};
  ${props => theme.media.tabletUp`
    max-width: 400px;
    `};
  ${props => theme.media.desktopUp`
    max-width: none;
  `};
`;

const ButtonRow = styled.div`
  display: flex;
  width: 100%;
  ${() => theme.media.tabletUp`
    padding-top: 0px;
  `};
  ${() => theme.media.desktopUp`
    padding-top: 32px;
  `};
`;

const PrimaryBtnWrapper = styled.a`
  text-decoration: none;
  display: block;
  margin: 0;
`;

const SecondaryBtnWrapper = styled.a`
  text-decoration: none;
  display: block;
  margin-left: 16px;
`;

const CalendlyPrimaryButton = styled(CalendlyBtn)`
  ${ModuleBtnStyle};
  color: ${() => theme.colors.green2};
`;

const CalendlyOutlineButton = styled(CalendlyBtn)`
  ${ModuleBtnStyle};
  height: auto;
  display: block;
  margin-left: 16px;
  background-color: transparent;
  color: ${() => theme.colors.green5};
  border: ${() => theme.colors.green5} solid 1px;
  &:hover {
    background: ${() => theme.colors.green1};
  }
`;

const PardotOutlineButton = styled(ModuleOutlineBtn)`
  ${ModuleBtnStyle};
  height: auto;
  display: block;
  margin-left: 16px;
  background-color: transparent;
  color: ${() => theme.colors.green5};
  border: ${() => theme.colors.green5} solid 1px;
  &:hover {
    background: ${() => theme.colors.green1};
  }
`;

const FinalCta = ({
  title,
  maxTitleWidth,
  subtitle,
  primaryBtnTxt,
  primaryBtnHref,
  customPrimaryBtn,
  secondaryBtnTxt,
  secondaryBtnHref,
  className,
  hideSecondButton
}) => {
  const modalRef = useRef();
  const trialModalRef = useRef();

  let mainBtn = <CalendlyPrimaryButton>{primaryBtnTxt}</CalendlyPrimaryButton>;
  if (primaryBtnHref) {
    if (primaryBtnHref == 'trial-modal') {
      mainBtn = (<>
        <PrimaryBtnWrapper onClick={(e) => {
            trialModalRef.current.openModal();
            e.preventDefault();
          }} href={'#'}>
          <ModulePrimaryBtn>{primaryBtnTxt}</ModulePrimaryBtn>
        </PrimaryBtnWrapper>

        <Modal style={{marginTop: '-300px'}} ref={trialModalRef}>
          <h2 style={{fontFamily: 'Grenette', fontSize: '36px', fontWeight: 400, letterSpacing: '-1.12px', lineHeight: '47px', marginBottom: '10px'}}>Try Mode for free</h2>
          <PardotForm config={JSON.stringify({
            id: "mode-form-signup-footer",
            embedContext: "page",
            embedStyle: { "maxWidth": "100%", "width": "380px" },
            strings: { "button_text": "Continue" },
            formUrl: "https://go.thoughtspot.com/l/710713/2024-03-05/btbvm",
            modeSignupForm: true,
            formValidationSettings: { "email": ["role_blacklist"] }
          })} />
        </Modal>
      </>);
    } else {
      mainBtn = (
        <PrimaryBtnWrapper href={primaryBtnHref}>
          <ModulePrimaryBtn>{primaryBtnTxt}</ModulePrimaryBtn>
        </PrimaryBtnWrapper>
      );
    }
  } else if (customPrimaryBtn) {
    mainBtn = customPrimaryBtn;
  }
  let secondaryBtn = (
    <div data-pardot-button="1">
      <PardotOutlineButton data-pardotmodal="true" onClick={() => {
        modalRef.current.openModal()
      }}>{secondaryBtnTxt}</PardotOutlineButton>
    </div>
  );
  if (secondaryBtnHref) {
    secondaryBtn = (
      <SecondaryBtnWrapper href={secondaryBtnHref}>
        <ModuleOutlineBtn>{secondaryBtnTxt}</ModuleOutlineBtn>
      </SecondaryBtnWrapper>
    );
  }

  return (
    <StyledCta className={className}>
      <Container>
        <RelativeWrapper>
          <StretchLogoDesktop />
          <StretchLogoMobile />
          <CtaContent>
            <StyledTitle maxTitleWidth={maxTitleWidth}>{title}</StyledTitle>
            {subtitle && <StyledSubTitle>{subtitle}</StyledSubTitle>}
            <ButtonRow>
              {mainBtn}
              {!hideSecondButton && secondaryBtn}
              {!hideSecondButton && <Modal ref={modalRef}>
                <div>
                  <PardotForm config={JSON.stringify({
                      "id": "product-tour-mode",
                      "embedContext": "page",
                      "strings": {"button_text": "Submit"},
                      "embedStyle": { "maxWidth": "100%", "width": "380px" },
                      "styleOverrides": ".suffix {color: white;}.form .submit_button{background-color: #D7EE8A; color: #000;}.form {padding: 15px 0;}",
                      "doGeolocation": true,
                      "formUrl": "https://go.thoughtspot.com/l/710713/2023-09-22/b3tmj",
                      "redirectUrl": "https://mode.com/product-tour/",
                      "sharedConfigs": "mode"
                    })} heading={''}></PardotForm>
                </div>
              </Modal>}
            </ButtonRow>
          </CtaContent>
        </RelativeWrapper>
      </Container>
    </StyledCta>
  );
};

FinalCta.defaultProps = {
  title: "Get more from your data",
  maxTitleWidth: "600px",
  subtitle: "Your team can be up and running in 30 minutes or less.",
  primaryBtnTxt: "Try for free",
  primaryBtnHref: "trial-modal",
  secondaryBtnTxt: "Request demo",
  secondaryBtnHref: "",
  className: "light",
  hideSecondButton: false,
  customPrimaryBtn: null
};

export default FinalCta;
